import Dialog from 'quasar/src/plugins/Dialog.js';
import { custom as dxDialog } from 'devextreme/ui/dialog'

export const useDialog = () => {
  const genericDialog = (title, message, config) => Dialog.create({ title: title, message: message, ...config })

  const customDialog = (confirmTitle, confirmMessage, yesText, noText) => {
    return new Promise((resolve) => {
      const dialog = dxDialog({
        title: confirmTitle,
        messageHtml: confirmMessage,
        showTitle: true,
        dragEnabled: true,
        rtlEnabled: false,
        buttons: [
        {
          text: yesText,
          type: 'default',
          onClick: () => {
            resolve(true)
          }
        },
        {
          text: noText,
          type: 'normal',
          onClick: () => {
            resolve(false)
          }
        }
        ]
      })

      dialog.show()
    })
  }

  return { genericDialog, customDialog }
}
